const accountPrefix = accountId => `/${accountId}`;

const imagePrefix = accountId => `${accountPrefix(accountId)}/ai-image-generation/images`;
const videoPrefix = accountId => `${accountPrefix(accountId)}/ai-video-generation/videos`;
const textPrefix = (accountId, campaignId) =>
    `${accountPrefix(accountId)}/campaigns/${campaignId}/ai-text-generation/content`;
const pageDataPrefix = accountId => `${accountPrefix(accountId)}/ai-page-data-generation/content`;

export const aiGenerationApiFactory = ({ callGetApi, callPostApi }) => ({
    // text
    getAIGeneratedTitles: ({ accountId, campaignId, ...options }) =>
        callGetApi(`${textPrefix(accountId, campaignId)}/title`, { ...options }),
    getAiRephrasedTitles: ({ accountId, campaignId, ...options }) =>
        callGetApi(`${textPrefix(accountId, campaignId)}/rephrase`, { ...options }),
    getDKIFixSuggestions: ({ accountId, campaignId, ...options }) =>
        callGetApi(`${textPrefix(accountId, campaignId)}/fix-dki`, { ...options }),

    // page data
    getPageProductDetails: ({ accountId, url, ...options }) =>
        callGetApi(`${pageDataPrefix(accountId)}/landing-page`, { urlPageMetadata: url, ...options }),

    // images
    getAIGeneratedImagesFromImage: ({ accountId, ...requestBody }) =>
        callPostApi(`${imagePrefix(accountId)}/from-image`, requestBody),
    getAIGeneratedMotionFromImage: ({ accountId, isRegenerated, ...options }) =>
        callPostApi(`${videoPrefix(accountId)}/from-image?isRegenerated=${isRegenerated}`, { ...options }),
    getAIGeneratedImagesFromPrompt: ({ accountId, ...options }) =>
        callPostApi(`${imagePrefix(accountId)}/from-prompt`, { ...options }),
    getAIGeneratedReplacedBackgrounds: ({ accountId, campaignId, foregroundMask, ...options }) =>
        callPostApi(`${imagePrefix(accountId)}/replace-background?campaignId=${campaignId}`, {
            foregroundMaskInBase64: foregroundMask,
            ...options,
        }),
    getAIGeneratedSegmentAnything: ({ accountId, campaignId, ...options }) =>
        callPostApi(`${imagePrefix(accountId)}/segment-anything/mask-generation?campaignId=${campaignId}`, {
            ...options,
        }),
    getAIGeneratedOutcropImage: ({ accountId, campaignId, ...body }) =>
        callPostApi(`${imagePrefix(accountId)}/outcrop-image?campaignId=${campaignId}`, { ...body }),
});
